@import "/src/styles/mixins.sass"

.container
    height: 100%
    display: flex
    justify-content: center
    align-items: center
    gap: 2rem

    @include mappy-bp(max tablet)
        flex-direction: column

    .left
        @include header

    .left
        font-size: 8rem
        color: var(--color-black-primary-disabled)

    .right
        display: flex
        flex-direction: column
        gap: 1rem

        .header
            @include header

        .header
            font-size: 2rem
            color: var(--color-black-primary-disabled)

        .text
            @include text
            color: var(--color-black-primary-disabled)
